type Props = {
	text: string;
};
export const CheckText = (props: Props) => {
	return (
		<div className={"flex items-center "}>
			<img src={"/png/check.png"} className={"w-8 h-auto"} alt={"check"} />
			<p className={"ml-2 font-bold text-sm"}>{props.text}</p>
		</div>
	);
};
